import {useCallback, useEffect, useState} from 'preact/hooks';
import {throttle} from 'lodash';

export const useQfScroll = id => {
    const [showElement, setShowElement] = useState(false);
    const handleScroll = useCallback(
        throttle(() => {
            const clients = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            const showId = document.getElementById(id);
            setShowElement(showId.getBoundingClientRect().top <= clients);
        }, 300),
        [id]
    );

    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.addEventListener('scroll', handleScroll);
        }
        return () => window.removeEventListener('scroll', handleScroll);
    }, [handleScroll]);

    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const ua = navigator.userAgent;
        const isMobile = /Mobile|Android|iP(hone|od|ad)|IEMobile|Opera Mini/i.test(ua);
        setIsMobile(isMobile);
    }, []);

    return {
        showElement,
        handleScroll,
        isMobile
    };
};

export const useQfScreen = () => {
    const [screenWidth, setScreenWidth] = useState(null);

    const handleResize = useCallback(
        throttle(() => {
            setScreenWidth(window.innerWidth);
        }, 100),
        []
    );

    useEffect(() => {
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [screenWidth]);

    return {
        screenWidth,
        setScreenWidth
    };
};

export const useVisibleVideoPlay = (id, active, hasBg = false) => {
    // hasBg为true时，是视频带有长背景，长背景会先出现
    useEffect(() => {
        const video = document.getElementById(id);
        if (video) {
            // 配置Intersection Observer
            let observer = new IntersectionObserver(
                entries => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            // 计算可见比例
                            const ratio = entry.intersectionRatio;
                            // 当可见比例达到60%时播放视频
                            if (hasBg) {
                                if (ratio >= 0.7 && video.paused) {
                                    video.load();
                                    video.onloadeddata = () => {
                                        requestAnimationFrame(() => {
                                            video.play();
                                        });
                                    };
                                }
                            } else {
                                if (ratio >= 0.6 && video.paused) {
                                    video.play().catch(err => {
                                        console.log('err', err);
                                    });
                                }
                            }
                        }
                    });
                },
                {
                    threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1]
                }
            );

            // 开始观察视频元素
            observer.observe(video);
        }
    }, [active, id]);
};
